import listActions from 'src/modules/subscriptionTier/list/subscriptionTierListActions';
import SubscriptionTierService from 'src/modules/subscriptionTier/subscriptionTierService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'SUBSCRIPTION_TIER_UNARCHIVE';

const subscriptionTierUnarchiveActions = {
  UNARCHIVE_STARTED: `${prefix}_UNARCHIVE_STARTED`,
  UNARCHIVE_SUCCESS: `${prefix}_UNARCHIVE_SUCCESS`,
  UNARCHIVE_ERROR: `${prefix}_UNARCHIVE_ERROR`,

  UNARCHIVE_ALL_STARTED: `${prefix}_UNARCHIVE_ALL_STARTED`,
  UNARCHIVE_ALL_SUCCESS: `${prefix}_UNARCHIVE_ALL_SUCCESS`,
  UNARCHIVE_ALL_ERROR: `${prefix}_UNARCHIVE_ALL_ERROR`,

  doUnarchive: (id) => async (dispatch) => {
    try {
      dispatch({
        type:
          subscriptionTierUnarchiveActions.UNARCHIVE_STARTED,
      });

      await SubscriptionTierService.unarchiveAll([id]);

      dispatch({
        type:
          subscriptionTierUnarchiveActions.UNARCHIVE_SUCCESS,
      });

      Message.success(
        i18n('entities.subscriptionTier.unarchive.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/subscription-tier');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          subscriptionTierUnarchiveActions.UNARCHIVE_ERROR,
      });
    }
  },

  doUnarchiveAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type:
          subscriptionTierUnarchiveActions.UNARCHIVE_ALL_STARTED,
      });

      await SubscriptionTierService.unarchiveAll(ids);

      dispatch({
        type:
          subscriptionTierUnarchiveActions.UNARCHIVE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n(
          'entities.subscriptionTier.unarchiveAll.success',
        ),
      );

      getHistory().push('/subscription-tier');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          subscriptionTierUnarchiveActions.UNARCHIVE_ALL_ERROR,
      });
    }
  },
};

export default subscriptionTierUnarchiveActions;
